import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

export default function OptionalSocialStep({ formData, setFormData }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <h2>{t("Start.optionalContactInfo")}</h2>

      {/* Facebook */}
      <div className="prefixed-input">
        <span className="prefix">www.facebook.com/</span>
        <input
          ref={inputRef}
          type="text"
          value={formData.facebookUrl}
          onChange={e =>
            setFormData({ ...formData, facebookUrl: e.target.value })
          }
        // placeholder="your page"
        />
      </div>

      {/* Instagram */}
      <div className="prefixed-input">
        <span className="prefix">www.instagram.com/</span>
        <input
          type="text"
          value={formData.instagramUrl}
          onChange={e =>
            setFormData({ ...formData, instagramUrl: e.target.value })
          }
        // placeholder="your profile"
        />
      </div>
    </>
  );
}
